export function getFrameFromAnimation(animation, time) {
    if(animation.frames == undefined) {
        return animation
    }

    const duration = animation.frames[animation.frames.length - 1].time

    // if(animation.isLoop == true) {
    time %= duration

    return animation.frames.find((frame, index) => {
        if(animation.frames[index + 1] == undefined
        || animation.frames[index + 1].time > time) {
            return true
        }
    })
}

export function getImageFromAnimation(animation, time) {
    const frame = getFrameFromAnimation(animation, time)
    return frame?.image
}
